import { useLang } from 'hooks/lang';

import { issueStatuses, loaders } from 'entities';

import { Box } from 'components/Blocks';
import { CirclePlusIcon, IssueIcon, UserSpeakIcon } from 'components/Icons';

import { SideLink } from './SideLink';
import { InvoiceLink } from './InvoiceLink';

import { usePendingActions } from 'providers/PendingActions';

export function SidebarLinks() {
  const { t } = useLang();
  const pendingActions = usePendingActions();

  const issuesCounts = loaders.projects.getIssueCounts.use({
    defaultValue: {},

    realTimeSubscription: {
      type: 'ISSUE_COUNTS',

      onMessage: ({ counts }) => counts,
    },
  });

  const activeIssues = issuesCounts.errorOrLoading
    ? ''
    : issuesCounts.data[issueStatuses.active.code];

  return (
    <>
      <SideLink
        to="createProject"
        label={t('create-project')}
        icon={<CirclePlusIcon size={22} />}
      />

      {!!pendingActions.total && (
        <SideLink
          to="pendingActions"
          label={t('pending-actions')}
          icon={
            <Box
              border="circle"
              size={24}
              className="bg-destructive-dark text-sm text-destructive-foreground"
            >
              {pendingActions.total}
            </Box>
          }
        />
      )}

      <InvoiceLink />

      <SideLink to="recruitmentHome" label={t('recruitments')} icon={<UserSpeakIcon size={22} />} />

      <SideLink
        to="issuesHome"
        icon={<IssueIcon size={22} />}
        label={
          <span className="-ml-3">
            {activeIssues} {t('issues')}
          </span>
        }
      />
    </>
  );
}
